import styled from 'styled-components';
import {GameJackpotBarPrizesWrapperDefaultBox} from './game-jackpot-bar-prizes-wrapper.default.box';

export const GameJackpotBarPrizesWrapperMrgreenBox = styled(GameJackpotBarPrizesWrapperDefaultBox)`  

    @media ${({theme}) => theme.mediaQuery.lAndAbove + " or " + theme.mediaQuery.landscape} {
           justify-content: flex-start;
           margin-left: -7rem;
    }
`;